module.exports = __webpack_public_path__ + "static/media/ma.68c6eafb.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ma.svg
// module id = 1290
// module chunks = 0